var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('main-pane',{staticClass:"left-pane"}),_vm._v(" "),(_vm.$responsive.mobile)?[_c('transition',{attrs:{"name":"mobile-page","duration":"150"}},[_c('div',{key:_vm.$route.fullPath,staticClass:"page-wrapper"},[_c('router-view')],1)])]:_c('div',{staticClass:"page-wrapper"},[_c('router-view')],1)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b0e686","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Main.vue
// module id = 499
// module chunks = 0